import { ROUTES } from '@/constants/routes';

/** Backend icon name -> bootstrap-icons class. Add entries as the backend adds icons. */
const ICON_MAP: Record<string, string> = {
  home: 'bi-house',
  store: 'bi-shop',
  printer: 'bi-printer',
  tag: 'bi-tag',
  alert: 'bi-exclamation-triangle',
  rupee: 'bi-currency-rupee',
  lock: 'bi-lock',
  shield: 'bi-shield-check',
  users: 'bi-people',
  list: 'bi-list-ul',
};

export const toIconClass = (icon: string) => ICON_MAP[icon] ?? 'bi-circle';

/** Backend path "/vendors" -> frontend path "/admin/vendors". Empty stays undefined. */
export const toAdminPath = (path: string) =>
  path ? `${ROUTES.admin.root}${path}` : undefined;